import React from "react";
import { Form, SelectPicker } from "rsuite";
import { useDispatch, useSelector } from "react-redux";
import {
  EDITABLE_FILTER,
  selectEditableFilter,
  selectHasNegotiatedRateplans,
  setEditableFilter,
  setSelectedRateplan,
  selectRateplans,
} from "../../slices/rateplanSlice";
import { useIsOfflineProperty } from "../../contexts/PropertyStoreContext";
import "./editable-rateplan-filter.scss";

const FILTER_OPTIONS = [
  { label: "All Rate Plans", value: EDITABLE_FILTER.ALL },
  { label: "Editable Rate Plans", value: EDITABLE_FILTER.EDITABLE },
  { label: "Non-editable Rate Plans", value: EDITABLE_FILTER.NON_EDITABLE },
];

const EditableRatePlanFilter = () => {
  const dispatch = useDispatch();
  const isOffline = useIsOfflineProperty();
  const hasNegotiated = useSelector(selectHasNegotiatedRateplans);
  const editableFilter = useSelector(selectEditableFilter);
  const rateplans = useSelector(selectRateplans);

  // Only show for dynamic hotels with at least one negotiated rateplan
  if (isOffline || !hasNegotiated) {
    return null;
  }

  const handleFilterChange = (value) => {
    dispatch(setEditableFilter(value));

    // Auto-select first rateplan matching the new filter
    const filtered = rateplans.filter((rp) => {
      if (value === EDITABLE_FILTER.ALL) return true;
      if (value === EDITABLE_FILTER.EDITABLE)
        return rp.additionalData?.isNegotiated === true;
      return !rp.additionalData?.isNegotiated;
    });

    if (filtered.length > 0) {
      const first = filtered[0];
      dispatch(
        setSelectedRateplan({
          label:
            first.code && first.name
              ? `${first.code}-${first.name}`
              : first.name || first.code,
          value: first.id,
          data: first,
        })
      );
    }
  };

  return (
    <div>
      <Form.Group className="editable-filter-container">
        <SelectPicker
          data={FILTER_OPTIONS}
          value={editableFilter}
          onChange={handleFilterChange}
          cleanable={false}
          searchable={false}
          className="editable-filter-picker"
          data-testid="editable-rateplan-filter"
        />
      </Form.Group>
    </div>
  );
};

export default EditableRatePlanFilter;
